export default __webpack_public_path__ + "static/media/shivada_jade_chunk.58289e71.png";